import render from './render'

export default {
  name: 'SimpleValue',

  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    count: {
      type: Number,
      default: 2
    }
  },

  computed: {
    isMany() {
      return this.value.length > this.count
    }
  },

  render
}
